module.exports = __webpack_public_path__ + "images/kurtosis-03-desktop.png";